export default "__VITE_ASSET__DSNgOkjF__"